import React, { useState, useRef, FC, PropsWithChildren } from 'react';
import { path, pathOr } from 'ramda';
import { useTranslations } from '@lang';
import { ToggleButton, OpenIndicator } from '../../../../../../../components';
import {
  OptionBoxWrapper,
  ControlsBox,
  ToggleOptionsButtonWrapper,
  ControlsWrapper,
} from './OptionsBox.styles';

const ICON_SIZE = 24;

export const OptionsBox: FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const descriptionRef = useRef(null);
  const descriptionElement = path(['current'], descriptionRef);
  const descriptionHeight = pathOr(0, ['children', '0', 'clientHeight'], descriptionElement);

  return (
    <OptionBoxWrapper>
      <ToggleOptionsButtonWrapper>
        <ToggleButton
          isSelected
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(!isOpen);
          }}
        >
          <>
            {t('room.extras.options')}
            <OpenIndicator width={ICON_SIZE} height={ICON_SIZE} $isOpen={isOpen} />
          </>
        </ToggleButton>
      </ToggleOptionsButtonWrapper>
      <ControlsBox isOpen={isOpen} ref={descriptionRef} descriptionHeight={descriptionHeight}>
        <ControlsWrapper isOpen={isOpen}>{children}</ControlsWrapper>
      </ControlsBox>
    </OptionBoxWrapper>
  );
};
